var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCongregating = function SvgCongregating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 192C149.019 192 192 149.019 192 96C192 42.9807 149.019 0 96 0C42.9807 0 0 42.9807 0 96C0 149.019 42.9807 192 96 192Z",
    fill: "#23476C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 75.5C81.5273 75.5 69.75 63.7227 69.75 49.25C69.75 34.7773 81.5273 23 96 23C110.473 23 122.25 34.7773 122.25 49.25C122.25 63.7227 110.473 75.5 96 75.5Z",
    fill: "#99B0C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.25 49.25C122.25 34.7773 110.473 23 96 23V75.5C110.473 75.5 122.25 63.7227 122.25 49.25Z",
    fill: "#8599AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 121C44.7965 121 39.75 115.953 39.75 109.75C39.75 103.547 44.7965 98.5 51 98.5C57.2035 98.5 62.25 103.547 62.25 109.75C62.25 115.953 57.2035 121 51 121Z",
    fill: "#C0D1E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81 121C74.7965 121 69.75 115.953 69.75 109.75C69.75 103.547 74.7965 98.5 81 98.5C87.2035 98.5 92.25 103.547 92.25 109.75C92.25 115.953 87.2035 121 81 121Z",
    fill: "#A4BBD3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111 121C104.797 121 99.75 115.953 99.75 109.75C99.75 103.547 104.797 98.5 111 98.5C117.203 98.5 122.25 103.547 122.25 109.75C122.25 115.953 117.203 121 111 121Z",
    fill: "#8EA8C3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.152 44.4013L100.85 39.0988L96.0009 43.9473L91.1521 39.0988L85.8496 44.4013L90.6981 49.25L85.8496 54.0988L91.1521 59.4013L96.0009 54.5528L100.85 59.4013L106.152 54.0988L101.304 49.25L106.152 44.4013Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141 121C134.797 121 129.75 115.953 129.75 109.75C129.75 103.547 134.797 98.5 141 98.5C147.203 98.5 152.25 103.547 152.25 109.75C152.25 115.953 147.203 121 141 121Z",
    fill: "#8599AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36 151V136C36 127.727 42.731 121 51 121C59.269 121 66 127.727 66 136V151H36Z",
    fill: "#C0D1E4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66 151V136C66 127.727 72.731 121 81 121C89.269 121 96 127.727 96 136V151H66Z",
    fill: "#A4BBD3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96 151V136C96 127.727 102.731 121 111 121C119.269 121 126 127.727 126 136V151H96Z",
    fill: "#8EA8C3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126 151V136C126 127.727 132.731 121 141 121C149.269 121 156 127.727 156 136V151H126Z",
    fill: "#8599AF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.849 59.4013L106.151 54.0988L101.303 49.25L106.151 44.4013L100.849 39.0988L96 43.9473V54.5528L100.849 59.4013Z",
    fill: "white"
  })));
};
export default SvgCongregating;